// Projects with a 3D model. The page and data live in public/stackmap/
// (copied from prototypes/stack-map by its tools/sync_site.sh). Each slug is
// the project page slug, so /single-property/<slug> and /3d-navigator/<slug>
// point at the same project.
export const STACKMAP_SLUGS = ["thomson-reserve", "lucerne-grand", "the-serra-residences", "vela-bay", "lentor-gardens-residences", "one-marina-gardens", "amberwood-at-holland", "dunearn-house", "zyon-grand", "promenade-peak", "newport-residences", "w-residences-marina-view-singapore", "union-square-residences"] as const;

export function hasStackmap(slug: string): boolean {
  return (STACKMAP_SLUGS as readonly string[]).includes(slug);
}

// section: inside a project page section; overlay: full screen over a page;
// page: the /3d-navigator/<slug> page.
export type StackmapEmbed = "section" | "overlay" | "page";

export function stackmapSrc(slug: string, propertyId: string, embed: StackmapEmbed, hash = ""): string {
  const query = new URLSearchParams({ p: slug, pid: propertyId, embed });
  const api = (process.env.NEXT_PUBLIC_API_URL || "").replace(/\/+$/, "");
  if (api) query.set("api", api);
  return `/stackmap/index.html?${query.toString()}${/^#[\w=&-]*$/.test(hash) ? hash : ""}`;
}

export const stackmapPoster = (slug: string) => `/stackmap/posters/${slug}.webp`;
// AIPROP 3D trademark, shown on every 3D picture and inside the 3D view.
export const STACKMAP_LOGO = "/stackmap/brand/aiprop-3d.svg";

// The 3D funnel: opened, tapped a home, saw the sign-up form, sent it.
// Live site only, so local and staging visits stay out of Google Analytics.
export function track3d(name: string, params: Record<string, string>): void {
  if (typeof window === "undefined" || !/(^|\.)aiproperty\.sg$/.test(window.location.hostname)) return;
  const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
  if (typeof gtag === "function") gtag("event", name, params);
}
